import { createHttpClientWithBearer } from '@invivodf/common/src/infrastructure/httpClient'
import { AxiosInstance } from 'axios'

export interface User {
  email: string
  optIn: boolean
  firstName: string
  lastName: string
  id: string
  loyalty?: {
    cardNumber: string
    fileNumber: string
  }
  phoneNumber?: string
  phoneNumberIndicator?: string
  customUserId?: string
  createdAt?: string
}

const getEnv = (variableName: string): string | null => {
  return window.env[variableName] ?? null
}

const getUsersApiUrl = (path?: string): string => {
  return `${getEnv('USER_API_HOST')}/v1/users${path || ''}`
}

export class UserService {
  private readonly api: AxiosInstance

  constructor() {
    this.api = createHttpClientWithBearer(getUsersApiUrl(), { timeout: 20000 })
  }

  async getUserById(id: string): Promise<User> {
    return this.api
      .get<User>(`/${id}`)
      .catch((err) => {
        throw err
      })
      .then((res) => res.data)
  }

  async deleteUser(id: string): Promise<User> {
    return this.api
      .delete<User>(`/${id}`)
      .catch((err) => {
        throw err
      })
      .then((res) => res.data)
  }

  async getUserByEmail(email: string): Promise<User> {
    return this.api
      .get<User>(`/email/${email}`)
      .catch((err) => {
        throw err
      })
      .then((res) => res.data)
  }

  async findUsersByEmail(email: string): Promise<User[]> {
    return this.api
      .get<User[]>(`/search/${email}`)
      .catch((err) => {
        throw err
      })
      .then((res) => res.data)
  }

  async updateUserEmail(auth0: string, email): Promise<User> {
    return this.api
      .put<User>(`/${auth0}/email`, { email })
      .catch((err) => {
        throw err
      })
      .then((res) => res.data)
  }

  async updateUser(auth0: string, user: Partial<User>): Promise<User> {
    return this.api
      .put<User>(`/${auth0}`, user)
      .catch((err) => {
        throw err
      })
      .then((res) => res.data)
  }

  async searchUsers(query: string): Promise<User[]> {
    return this.api
      .get<User[]>(`/query/${query}`)
      .catch((err) => {
        throw err
      })
      .then((res) => res.data)
  }
}
